import React from 'react'
import './Product.css'
import { useStateValue } from '../StateProvider'

function Product({ id, name, image, price, rating, price_cancelled }) {

    const[{}, dispatch] = useStateValue()

    const addToCart =() => {
        dispatch({
            type: "ADD_TO_CART",
            item: {
                id:id,
                name:name,
                image:image,
                price:price,
                rating:rating,
                price_cancelled:price_cancelled
            }
        })
    }

    return (
        <div className="product" >
            <div className ="product__info">
                <p>{name}</p>   
                <p className="product__price">
                <strong> 
                    {new Intl.NumberFormat('en-IN', {
                    style: 'currency',
                    currency: 'INR'}).format(price)}
                    </strong>
                    <small>  <strike>₹ {price_cancelled}</strike></small>
                </p>  
                <div className="product__rating">
                    { Array(rating)
                        .fill() 
                        .map((i) => (
                            // eslint-disable-next-line jsx-a11y/accessible-emoji
                            <p>🌟</p>
                        ) ) }
                </div>
            </div>

            <img src={image} alt ="" />
            <button onClick={() => {addToCart()}} >Add to Cart</button>       
        </div>
    )
}

export default Product
